"use client";

/*
 * WARNING: beforeInteractive scripts belong to RootLayout!
 */
import React, { JSX } from "react";

import Script from "next/script";

import { getGtagConfigSnippet, getGtagJsSrc } from "@/components/vendor/Analytics/gtagSnippet";
import { segmentSnippet } from "@/components/vendor/Analytics/segmentSnippet";

const ga4tagId = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID;

export default function ExternalScripts(): JSX.Element {
  return (
    <>
      {/*
       * Segment first: pre-seeds segment_anonymous_id + analytics.setAnonymousId(id)
       * before gtag config fires cold-load page_view.
       */}
      {process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY && (
        <Script
          strategy="afterInteractive"
          id="segment-analytics"
          dangerouslySetInnerHTML={{
            __html: segmentSnippet,
          }}
        />
      )}
      {process.env.NEXT_PUBLIC_BASEURL && (
        <Script
          strategy="lazyOnload"
          id="ada-chat"
          src={`${process.env.NEXT_PUBLIC_BASEURL}/gatsby-assets/js/ada.js`}
        />
      )}

      {/*
       * NT2-30510: gtag.js + cold page_view on every page.
       */}
      {ga4tagId && (
        <>
          <Script strategy="afterInteractive" id="ga4-gtag-js" src={getGtagJsSrc(ga4tagId)} />
          <Script
            strategy="afterInteractive"
            id="ga4-gtag-config"
            dangerouslySetInnerHTML={{
              __html: getGtagConfigSnippet(ga4tagId),
            }}
          />
        </>
      )}
    </>
  );
}
